export default "__VITE_ASSET__df23f034__"